import { FormattedMessage, useIntl } from "react-intl";

import { useActiveOrganization } from "common/account/active_organization";
import { useQuery } from "util/graphql";
import Tab from "common/core/tabs/tab";
import { useA11y } from "common/accessibility";
import { useDocumentTitles } from "util/document_title";

import OrganizationScheduleQuery from "./schedule_query.graphql";

export const ORG_NOTARY_HOURS_ROUTE = "notary-hours";

export function OrganizationNotaryHoursTab() {
  useA11y().useDocumentEntitler({
    title: useIntl().formatMessage(useDocumentTitles().settingsNotaryHours),
  });
  const [activeOrganizationId] = useActiveOrganization();

  const { data, loading } = useQuery(OrganizationScheduleQuery, {
    variables: { organizationId: activeOrganizationId! },
  });

  if (loading) {
    return null;
  }

  const organization = data?.organization;
  if (organization?.__typename !== "Organization") {
    throw new Error(`Expected Organization, got ${organization?.__typename}`);
  }

  if (!organization.notarySchedulingEnabled) {
    return null;
  }

  return (
    <Tab to={ORG_NOTARY_HOURS_ROUTE}>
      <FormattedMessage id="6fd34129-0bd0-420d-9e97-523fa5befb99" defaultMessage="Notary Hours" />
    </Tab>
  );
}

export { NotaryHoursSetting as OrganizationNotaryHours } from "./notary_hours";
